define('responsive-gameday/views/distributors/viewDistributors/PitchFXDistributor',['require','exports','module','./ViewDistributorBase','../../Monitor/Events/ViewModelUpdateEvents','message-service/message-service','../events/DistributionEvents','extant/extant','gameday-resource-path/gameday-resource-path','Responsive/util/imageDensity'],function(require,exports,module) {
    var ViewDistributorClass = require("./ViewDistributorBase"),
        UpdateEvents = require("../../Monitor/Events/ViewModelUpdateEvents"),
        MessageService = require("message-service/message-service"),
        DistEvents = require("../events/DistributionEvents"),
        exists = require("extant/extant"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        imageDensity = require( 'Responsive/util/imageDensity' );

    var Superclass;

    function PitchFXDataPack(game){
        this.game=game;
        var play = game.getCurrentPlay(),
            matchup = play.matchup||{};

        this.play = play;
        this.atbat = {
            num    : play.about.atBatIndex,
            batter : matchup.batter,
            pitcher: matchup.pitcher,
            stand  : matchup.batter && matchup.batter.stands,
            pitches: play.pitchEvents,
            getBatterImage : this.getBatterImage
        };
        this.hasPitchFX = game.gameData.gamedayType !== "N",
        this.hotcold = matchup.batterHotColdZones;
        this.stadium = game.gameData.venue.id;
        this.dayNight = game.gameData.datetime.dayNight;
    }

    PitchFXDataPack.prototype={
        getBatterImage : function(cut){
            cut=cut||'ipad';

            var atbat = (this.atbat || this);
                
            return resourcePath.get('batter',{
                team    : atbat.batter.uniform.toUpperCase(),
                cut     : cut,
                homeOrAway : atbat.batter.team,
                stand   : atbat.stand.toUpperCase()==="L"  ? "LEFT" : "RIGHT"
            });
        },
        getStadiumImages : function(view){
            var detail = imageDensity.choose(view, '','','@2x');
            return {
                defaultTop : resourcePath.get('stadiumTop',{ 
                    density : detail,
                    phase   : this.dayNight
                }),
                top : resourcePath.get('stadiumTop',{ 
                    density : detail,
                    phase   : this.dayNight, 
                    id      : this.stadium
                }),
                bottom : resourcePath.get('stadiumBottom',{ 
                    density : detail
                })
            }
        }
    };

    function PitchFXDistributor() {
        Superclass.constructor.call(this);
        this.eventType = UpdateEvents.UPDATE_PITCHFX;
        MessageService.addListener.call(this, DistEvents.UPDATE_ALL, this.refresh);
        MessageService.addListener.call(this, UpdateEvents.REQUEST_PITCHFX_DATA, this.handleUpdateRequest);
    }

    ViewDistributorClass.spawn(PitchFXDistributor).define({
        prepDataForView: function() {
            this.dataPack = new PitchFXDataPack(this.game);
            // this.dataPack.
            this.dispatchUpdates();
        }
    });

    Superclass = PitchFXDistributor.superclass;

    return PitchFXDistributor;
});
